const ServiceList = {
  base_url: import.meta.env.VITE_API_ENDPOINT || 'https://api.stepx.vn',
  // Authentication endpoints
  login: 'POST /v1/auth/login',
  logout: 'DELETE /v1/auth/logout',
  refresh: 'POST /v1/auth/refresh',
  // Account endpoints
  createAccount: 'POST /v1/customers/:id/account',
  deleteAccount: 'DELETE /v1/customers/:id/account',
  // User endpoints
  getUsers: 'GET /v1/users',
  // Customer endpoints
  getCustomers: 'GET /v1/customers',
  getCustomer: 'GET /v1/customers/:id',
  createCustomer: 'POST /v1/customers',
  updateCustomer: 'PUT /v1/customers/:id',
  deleteCustomer: 'DELETE /v1/customers/:id'
};

export default ServiceList;
